export default __webpack_public_path__ + "static/media/330_dummy2016-tattoo01-de.9981ec7f.png";